import React from "react";
import FeatureDocumentation from "../../components/layouts/docsection";
import CollectionPage from "../../images/Collections.png"
import AddCollection from "../../images/addCollection.png"
 

const Collections = () => {
  const CollectionsDoc = {
    title: "Collections",
    description: "Learn how to create and manage product collections for marketing and promotions.",
    sections: [
      {
        title: "Overview",
        content:
          "Collections are temporary groupings of products created for specific marketing campaigns or promotions. Unlike categories, collections are designed to highlight select products for a limited time.",
        image: CollectionPage,
        imageAlt: "Product Collection",
        imageCaption: "Figure 1: View of Product Collections",
      },
      {
        title: "Manage Collections",
        content: "Guidelines for viewing and adding product collections.",
        image: AddCollection,
        imageAlt: "Product Collection Modal",
        imageCaption: "Figure 2: Detailed view of the Add Product Collection modal",
        subsections: [
          {
            title: "Steps to Add a Collection",
            content:
              "Follow these steps to add a new product collection. Collections appear as banners within the application, encouraging users to explore featured products.",
            steps: [
              "Name: Enter a name for the collection (e.g., 'Valentine's Day Collection'). Choose a name that reflects the theme or purpose of the collection.",
              "Description: Provide a description explaining the collection's purpose. For example, 'Celebrate Valentine's Day with our exclusive product lineup.'",
              "Banner: Design and upload a banner that visually represents the collection. This banner will be displayed prominently to attract customer attention.",
              "Add Products: Once the collection is created, click on the collection to add individual products. Select products that fit the collection's theme or promotion.",
            ],
          },
        ],
      },
    ],
  };
  
  return <FeatureDocumentation {...CollectionsDoc} />;
};

export default Collections;
